import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

type SetSearchParam = (value: string | undefined, clearKeys?: string[]) => void;

export const useSearchParam = (
  key: string,
): [string | null, SetSearchParam] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get(key);

  const setValue = useCallback<SetSearchParam>(
    (newValue, clearKeys = []) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);

        if (newValue === undefined) next.delete(key);
        else next.set(key, newValue);

        clearKeys.forEach((clearKey) => next.delete(clearKey));

        return next;
      });
    },
    [key, setSearchParams],
  );

  return [value, setValue];
};
